const AssessmentIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.00463 18.0289C8.0229 17.5285 6.66703 17.0299 4.93034 16.718C2.98027 16.3678 2.00619 16.1917 1.56412 15.675C1.12109 15.1574 1.12109 14.3287 1.12109 12.6715V6.15622C1.12109 4.34297 1.12109 3.43779 1.81003 2.87898C2.50088 2.32114 3.31038 2.46658 4.92938 2.75842C8.12719 3.33253 10.0323 4.97258 10.6897 5.66344L10.951 17.5052C11.3188 16.034 14.0083 14.1142 15.7735 13.0521C16.1755 12.8102 16.4308 12.3803 16.4308 11.9111V3.45692C17.3876 2.75842 18.8775 2.32114 19.5693 2.87994C20.2582 3.43874 20.2582 4.34489 20.2582 6.15717V12.6705C20.2582 14.3287 20.2582 15.1574 19.8152 15.675C19.3731 16.1917 18.3981 16.3678 16.4499 16.718C14.7123 17.0299 13.3564 17.5285 12.3737 18.0289C11.4092 18.5207 10.926 18.7666 10.6897 18.7666C10.4543 18.7666 9.97493 18.5227 9.01628 18.0348M9.00463 18.0289L9.01628 18.0348M9.00463 18.0289C9.00852 18.0309 9.0124 18.0328 9.01628 18.0348"
        stroke="currentColor"
        strokeWidth="2.24162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1034 13.7175C12.9224 14.9459 11.5517 17.3138 10.9267 18.4616C10.863 18.5786 10.6895 18.5334 10.6895 18.4002V5.98131C11.0865 5.2675 12.2223 3.22174 14.1648 1.83238C14.9829 1.24679 15.3914 0.953989 15.911 1.21999C16.4306 1.48791 16.4306 2.07734 16.4306 3.25523V11.7138C16.4306 12.3511 16.4306 12.6697 16.2995 12.8927C16.1694 13.1166 15.8134 13.3166 15.1034 13.7175Z"
        stroke="currentColor"
        strokeWidth="2.24162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default AssessmentIcon
